/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfSecurityQuestions } from '../../models/data-page-of-security-questions';

export interface SecurityQuestionGetSecurityQuestion$Params {
  Username?: string | null;
}

export function securityQuestionGetSecurityQuestion(http: HttpClient, rootUrl: string, params?: SecurityQuestionGetSecurityQuestion$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfSecurityQuestions>> {
  const rb = new RequestBuilder(rootUrl, securityQuestionGetSecurityQuestion.PATH, 'get');
  if (params) {
    rb.query('Username', params.Username, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfSecurityQuestions>;
    })
  );
}

securityQuestionGetSecurityQuestion.PATH = '/forgot/questionlist';
